import React, {Component} from 'react';
import CartScrollBar from './CartScrollBar';
//import Counter from './Counter';
import EmptyCart from '../empty-states/EmptyCart';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import { findDOMNode } from 'react-dom';
import T from 'i18n-react';
import moment from 'moment';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCart: false,
            cart: this.props.cartItems,
            mobileSearch: false
        };
    }

    handleCart = (e) => {
        e.preventDefault();
        this.setState({
            showCart: !this.state.showCart
        })
    };

    handleMobileSearch = (e) => {
        e.preventDefault();
        this.setState({
            mobileSearch: true
        })
    };

    handleClickOutside = (e) => {
        const cartNode = findDOMNode(this.refs.cartPreview);
        if (cartNode) {
            if (cartNode.classList.contains('active')) {
                if (!cartNode || !cartNode.contains(e.target)) {
                    this.setState({
                        showCart: false
                    });
                    e.stopPropagation();
                }
            }
        }
    };

    handleSubmit(e){
        e.preventDefault();
    }

    handleSearchNav(e){
        e.preventDefault();
        this.setState({
            mobileSearch: false
        }, function(){
            this.props.handleMobileSearch();
        })
    }

    handleCheckout = () => {
        if (this.props.totalItems > 0) {


            let newPostRefOrders = this.props.ordersInstance.push();

            // Get the unique key generated by push()
            let postId = newPostRefOrders.key;

            newPostRefOrders.set({
                [localStorage.getItem("userSessionId")]: {
                    products: this.props.cartItems,
                    timestamp: moment().locale('it').format("YYYY-MM-DD HH:mm:ss"),
                    isPaidCc: false,
                    isOrderDone: false,
                    postId: postId,
                    /*country: this.props.country,*/
                    isOrderCancelled: false
                }
            });

            this.props.cartItems.map((val) => {
                let availableNew = val.available - val.quantity;
                this.props.productsInstance.child(val.id).update({
                    available: availableNew
                });
            });
            this.props.handleOrderConfirmed(postId);
        }
    };

    parseNum = (num) => {
        let numFloat = num.toLocaleString(undefined, {minimumFractionDigits: 2});
        return this.props.locale === 'it' ? numFloat : numFloat.replace(",", ".");
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.cartItems.length === 0 && this.props.cartItems.length > 0) {
            this.setState({
                cart: [],
                showCart: false
            })
        } else {
            this.setState({
                cart: nextProps.cartItems
            })
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);

        let language = '';

        if (!localStorage.getItem('locale')) {

            language = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;

            // language would be something like es-ES or es_ES
            // However we store our files with format es.json or en.json
            // therefore retrieve only the first 2 digits
            if (language.length > 2) {
                language = language.split("-")[0];
                language = language.split("_")[0];
            }
        } else {
            language = localStorage.getItem('locale');
        }

        this.setState({
            locale: language
        })
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    render() {

        let cartItems;
        cartItems = this.state.cart.map(product => {
            return <li className="cart-item" key={product.name}>
                <img className="product-image" alt={product.name} src={product.image}/>
                <div className="product-info">
                    <p className="product-name">{product.name}</p>
                    <p className="product-price">{product.price && this.parseNum(product.price)}</p>
                </div>
                <div className="product-total">
                    <p className="quantity">{product.quantity > 1 ? T.translate("labels.nums") : T.translate("labels.num")} {product.quantity}</p>
                    <p className="amount">{this.parseNum(product.quantity * product.price)}</p>
                </div>
                <a href="javascript:void(0)" className="product-remove"
                   onClick={this.props.removeProduct.bind(this, product.id)}>×</a>
            </li>
        });
        let view;
        if (this.state.cart.length <= 0) {
            view = <EmptyCart/>
        } else {
            view = <CSSTransitionGroup transitionName="fadeIn"
                                       transitionEnterTimeout={500}
                                       transitionLeaveTimeout={300}
                                       component="ul"
                                       className="cart-items">{cartItems}</CSSTransitionGroup>
        }

        /*const countryList = [
            {
                "country": "it",
                "countryCode": "+39",
            },
            {
                "country": "gb",
                "countryCode": "+44",
            },
            {
                "country": "de",
                "countryCode": "+49",
            },
            {
                "country": "fr",
                "countryCode": "+33",
            },
            {
                "country": "es",
                "countryCode": "+34"
            }
        ];*/

        let tadaClass = this.props.cartBounce ? "tada" : " ";
        let wiggleClass = (this.state.cart.length > 0 && !this.props.cartBounce) ? " wiggle" : " ";

        return (
            <header>
                <div className="container">
                    <div className="brand">
                        <img className="logo"
                             src="/img/bestway-logo.png"
                             alt="Bestway Inflate Design Logo"/>
                    </div>

                    <div className="search">
                        <a className="mobile-search"
                           href="javascript:void(0);"
                           onClick={this.handleMobileSearch.bind(this)}>
                            <i className="fas fa-globe" />
                        </a>
                        <form action="#"
                              method="get"
                              className={this.state.mobileSearch ? "search-form active" : "search-form"}>
                            <a className="back-button" href="javascript:void(0);" onClick={this.handleSearchNav.bind(this)}>
                                <i className="fa fa-arrow-left" />
                            </a>

                            {/*<select ref="searchBox"
                                    value={this.props.country}
                                    className={`search-keyword`}
                                    onChange={this.props.handleChangeCountry}
                                    disabled={((!this.props.isOrderConfirmed && !this.props.isOrderDone) || this.state.isOrderCancelled) ? false : this.props.countryLock}>
                                <option value="it-d" data-code="it-d">{T.translate(`labels.selectYourCountry`)}</option>
                                {
                                    countryList.map((val, key) => {
                                        return (
                                            <option
                                                key={key}
                                                value={val.country}
                                                data-code={val.countryCode}>{T.translate(`labels.${val.country}`)}</option>
                                        )
                                    })
                                }
                            </select>&nbsp;&nbsp;*/}

                            <select onChange={this.props.handleChangeLocale}
                                    className="search-keyword"
                                    value={this.props.locale}>
                                <option value='it'>{T.translate("labels.ita")}</option>
                                <option value='en'>{T.translate("labels.eng")}</option>
                            </select>
                        </form>
                    </div>

                    {((!this.props.isOrderDone && !this.props.viewCompleteOrder && !this.props.isOrderConfirmed) || this.props.isOrderCancelled) &&
                    <div className="cart">
                        <div className="cart-info">
                            <table>
                                <tbody>
                                <tr>
                                    <td>{T.translate("labels.numOfItems")}</td>
                                    <td>:</td>
                                    <td><strong>{this.props.totalItems}</strong></td>
                                </tr>
                                <tr>
                                    <td>{T.translate("labels.subTotal")}</td>
                                    <td>:</td>
                                    <td><strong>&euro; {this.parseNum(this.props.total)}</strong></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <a className="cart-icon" href="javascript:void(0);" onClick={this.handleCart.bind(this)} ref="cartButton">
                            <i className={`fas fa-shopping-bag ${tadaClass} ${wiggleClass}`} />
                            {this.props.totalItems ? <span className="cart-count">{this.props.totalItems}</span> : ""}
                        </a>
                        <div className={this.state.showCart ? "cart-preview active" : "cart-preview"} ref="cartPreview">
                            <CartScrollBar>{view}</CartScrollBar>
                            {
                                this.state.cart.length > 0 &&
                                <div className="total-cart">{T.translate("labels.total")}&nbsp;&nbsp;
                                    &euro; {this.parseNum(this.props.total)}
                                </div>
                            }
                            <div className="action-block">
                                <button type="button"
                                        className={this.state.cart.length > 0 ? " " : "disabled"}
                                        onClick={this.handleCheckout}>
                                    {T.translate("labels.proceedToCheckout")}
                                </button>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </header>
        )
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js